import styled from 'styled-components';
import Base from "./Base";

import THEME_CONSTS from '~/consts/theme';

const ButtonSecondary = styled(Base)`
    color: ${THEME_CONSTS.BUTTON_SECONDARY_FONT_COLOR};
    background-color: ${THEME_CONSTS.BUTTON_SECONDARY_BG_COLOR};
`
export default ButtonSecondary;